<template>
  <span class="show-password-icon" @click="$emit('togglePass')">
    <img src="@/assets/images/show-password.png" alt="show password" v-show="isHidden">
    <img src="@/assets/images/hide-password.png" alt="hide password" v-show="!isHidden">
  </span>
</template>

<script>
  export default {
    props: {
      isHidden: {
        type: Boolean,
        required: true
      }
    }
  }
</script>
